import { render, staticRenderFns } from "./MenuCollapse.vue?vue&type=template&id=beeadfb8&scoped=true&"
import script from "./MenuCollapse.vue?vue&type=script&lang=js&"
export * from "./MenuCollapse.vue?vue&type=script&lang=js&"
import style0 from "./MenuCollapse.vue?vue&type=style&index=0&id=beeadfb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeadfb8",
  null
  
)

export default component.exports